// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__CLFCY","pagination_nav":"Pagination_pagination_nav__n0T8U","pagination_ul":"Pagination_pagination_ul__AX-wc"};